import ApiGateway from "../../aws/api-gateway/ApiGateway";
import { BranchingQueryDefinition, getDurationSecondsStr } from "@iotv/datamodel-core";
import { getObjectFromS3 } from "../../aws/s3/api/s3";
import { serviceDefinition } from 'internal-config';
const { S3: { warm_cache } } = serviceDefinition;
/**   */
export const getDashboardData = async (paramsIn) => {
    let res = { err: null, data: null };
    const { contextQuery, dashboardObjectTypeId } = paramsIn;
    const paramsOut = { ...paramsIn, };
    if (!contextQuery) {
        paramsOut.contextQuery = dashboardObjectTypeId;
    }
    else if (contextQuery instanceof BranchingQueryDefinition) {
        paramsOut = { contextQuery: contextQuery.dehydrate() };
    }
    const path = '/dashboard';
    const t0 = Date.now();
    const response = (await ApiGateway.post(path, paramsOut, 'ConsumerApi'));
    console.log(`getDashboardData (DAO) api in ${getDurationSecondsStr(t0)}`);
    const dashboardDataResponse = response;
    const s3KeyResponse = response;
    if (dashboardDataResponse.data?.contextQueryResponse) {
        res.data = dashboardDataResponse.data;
    }
    else if (s3KeyResponse.data?.s3Key) {
        const t1 = Date.now();
        const { err, data } = await getObjectFromS3({ bucketIdentifier: warm_cache.name, Key: s3KeyResponse.data.s3Key });
        console.log(`getDashboardData (DAO) s3 in ${getDurationSecondsStr(t1)}`, data);
        if (err) {
            res.err = err;
        }
        else if (data) {
            res.data = data;
        }
    }
    else if (response.err) {
        res.err = response.err;
    }
    else {
        console.log(`Unexpected result`, response);
    }
    return res;
};
